The current state of the application or position.
